module.exports = __webpack_public_path__ + "img/motorway_6x3.0a23e04d.svg";